import {
  faClock,
  faCog,
  faPlug,
  faBell,
  faClipboardCheck,
  faCommentDots,
  faFileImport
} from '@fortawesome/free-solid-svg-icons'
import SettingsSOP from '../SettingsSOP'
import SettingsIntegrations from '../SettingsIntegrations'
import SettingsNotifications from '../SettingsNotifications'
import SettingsQA from '../qualityAssurance/SettingsQA'
import SettingsSmsAutomations from '../SettingsSmsAutomations'
import SettingsCallImport from '../SettingsCallImport'
import { CallAvailabilityView } from '../callAvailability'
import { isDevelopment } from '../../../devAuth'

const menuItems = [
  {
    name: 'Call Availability (dev mode)',
    shortName: 'Calls (dev)',
    icon: faClock,
    devOnly: true,
    component: CallAvailabilityView,
    slug: 'call-availability'
  },
  {
    name: 'SOP Settings (dev mode)',
    shortName: 'SOP (dev)',
    icon: faCog,
    component: SettingsSOP,
    devOnly: true,
    slug: 'sop'
  },
  {
    name: 'Integrations (dev mode)',
    shortName: 'Integ. (dev)',
    icon: faPlug,
    component: SettingsIntegrations,
    devOnly: true,
    slug: 'integrations'
  },
  {
    name: 'Notifications',
    shortName: 'Notif.',
    icon: faBell,
    component: SettingsNotifications,
    adminOnly: true,
    slug: 'notifications'
  },
  {
    name: 'Quality Assurance',
    shortName: 'QA',
    icon: faClipboardCheck,
    component: SettingsQA,
    adminOnly: true,
    slug: 'quality-assurance'
  },
  {
    name: 'SMS Automations',
    shortName: 'SMS',
    icon: faCommentDots,
    component: SettingsSmsAutomations,
    adminOnly: true,
    slug: 'sms-automations'
  },
  {
    name: 'Call Import',
    shortName: 'Import',
    icon: faFileImport,
    component: SettingsCallImport,
    adminOnly: true,
    slug: 'call-import'
  }
]

// Every tab is admin-only or dev-only, so a non-admin outside dev mode sees none
export const getVisibleSettingsItems = (isAdmin) =>
  menuItems.filter((item) => (!item.adminOnly || isAdmin) && (!item.devOnly || isDevelopment))

export const hasVisibleSettingsItems = (isAdmin) => getVisibleSettingsItems(isAdmin).length > 0
